import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 1c.3 0 .6.2.7.5l2 6.6h6.6a.8.8 0 0 1 .4 1.3l-5.3 4 2 6.6a.7.7 0 0 1-1.1.8l-5.3-4-5.3 4a.8.8 0 0 1-1.1-.8l2-6.5-5.3-4A.8.8 0 0 1 1.8 8h6.5l2-6.6c0-.3.4-.5.7-.5Zm0 3.3L9.5 9c0 .4-.4.6-.7.6H4l4 3c.2.2.3.5.2.8l-1.5 4.8 3.8-3h1l3.8 3-1.5-4.8c0-.3 0-.6.3-.8l4-3h-5a.8.8 0 0 1-.6-.6L11 4.3Z"
    />
  </svg>
);
